import { of } from "@nozbe/watermelondb/utils/rx";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { Text } from "@towersystems/roam-common-native";
import { Colors, View } from "react-native-ui-lib";
import Sale from "../../../../../../../../utilities/data/model/Sale";

const getObserables = ({ sale }: { sale: Sale }) => ({
  customer: sale?.customer?.observe() || of(null),
});

interface CustomerPointsRendererProps
  extends ExtractedObservables<ReturnType<typeof getObserables>> {}

const CustomerPointsRenderer = ({ customer }: CustomerPointsRendererProps) => {
  const noPoints = customer ? customer.loyaltyPoints : 0;
  return (
    <View>
      <Text style={{ color: Colors.white, fontSize: 18, fontWeight: "bold" }}>
        {noPoints} Loyalty Points
      </Text>
    </View>
  );
};

export const CustomerPoints = withObservables(
  ["sale"],
  getObserables
)(CustomerPointsRenderer);
